import { PopoverAnchor, Popover, PopoverContent } from "..";
import { INPUT_LIMITS } from "../../input-limits";
import GlobalSketchPicker from "../globalsketchpicker";
import "./singleborder.scss";
import React, { useState } from "react";

function hasUnits(units) {
  return Array.isArray(units) && !!units.length;
}

function parseQuantityAndUnitFromRawValue(
  rawValue,
  allowedUnits,
  DEFAULT_UNIT,
) {
  let trimmedValue;
  let quantityToReturn;

  if (typeof rawValue !== "undefined" || rawValue === null) {
    trimmedValue = `${rawValue}`.trim();
    const parsedQuantity = parseFloat(trimmedValue);
    quantityToReturn = !isFinite(parsedQuantity) ? undefined : parsedQuantity;
  }

  const unitMatch = trimmedValue?.match(/[\d.\-\+]*\s*(.*)/);
  const matchedUnit = unitMatch?.[1]?.toLowerCase();
  let unitToReturn;
  if (hasUnits(allowedUnits)) {
    const match = allowedUnits.find((item) => item.value === matchedUnit);
    unitToReturn = match?.value ? match?.value : DEFAULT_UNIT.value;
  } else {
    unitToReturn = DEFAULT_UNIT.value;
  }

  return [quantityToReturn?.toString(), unitToReturn];
}

function SingleBorderInput({
  value,
  onChange,
  style,
  width,
  resetValue = "",
  minLength,
  maxLength,
  units = [
    {
      value: "px",
      label: "px",
    },
    {
      value: "%",
      label: "%",
    },
    {
      value: "rem",
      label: "rem",
    },
    {
      value: "em",
      label: "em",
    },
    {
      value: "vh",
      label: "vh",
    },
    {
      value: "vw",
      label: "vw",
    },
  ],
  borderStyles = [
    {
      value: "dotted",
      label: "dotted",
    },
    {
      value: "dashed",
      label: "dashed",
    },
    {
      value: "solid",
      label: "solid",
    },
  ],
}) {
  const [openPopOver, setOpenPopOver] = useState(false);

  const [parsedQuantity, parsedUnit] = parseQuantityAndUnitFromRawValue(
    value?.width,
    units,
    {
      value: "px",
      label: "px",
    },
  );

  const handleNumberChange = (e) => {
    const { value: inputValue } = e.target;
    if (inputValue === "") {
      onChange({ ...value, width: "" });
      return;
    }
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === "" || inputValue === "-") {
      onChange({
        ...value,
        width: inputValue + parsedUnit,
        ...(value?.style ? {} : { style: "solid" }),
        ...(value?.color ? {} : { color: "#666666" }),
      });
    }
  };

  const handleUnitChange = (newUnit) => {
    onChange({ ...value, width: parsedQuantity + newUnit.target.value });
  };

  const handleBorderStyleChange = (newStyle) => {
    onChange({ ...value, style: newStyle.target.value });
  };

  const handleBlur = () => {
    if (parsedQuantity === undefined || parsedQuantity === null) {
      return;
    }
    let valueTemp = parsedQuantity;
    if (
      parsedQuantity.charAt(parsedQuantity.length - 1) === "." ||
      parsedQuantity === "-"
    ) {
      valueTemp = parsedQuantity.slice(0, -1);
    }
    onChange({
      ...value,
      width: valueTemp.replace(/0*(\d+)/, "$1") + parsedUnit,
    });
  };

  return (
    <div
      className={`grigora-border-input border w-fit flex rounded-[6px] ${style}`}
    >
      <div className="flex">
        <input
          value={parsedQuantity ? parsedQuantity : ""}
          onChange={handleNumberChange}
          onBlur={handleBlur}
          minLength={
            minLength ? minLength : INPUT_LIMITS["border-input"].minlength
          }
          maxLength={
            minLength ? minLength : INPUT_LIMITS["border-input"].maxlength
          }
          className={`grigora-border__input p-1 w-9 focus:rounded-l focus:rounded-r-none focus:outline outline-blue-500 bg-editor-input-selected focus-visible:outline-none `}
          type="text"
        />
        <select
          value={parsedUnit}
          onChange={handleUnitChange}
          className="grigora-border__select p-1 focus:outline outline-blue-500 bg-editor-input-selected focus-visible:outline-none"
        >
          {units.map(function (item, i) {
            return (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            );
          })}
        </select>
      </div>
      <select
        value={value?.style}
        style={{ textAlignLast: "center" }}
        onChange={handleBorderStyleChange}
        className=" focus:outline outline-blue-500 bg-editor-input-selected focus-visible:outline-none"
      >
        {borderStyles.map(function (item, i) {
          return (
            <option value={item.value} key={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
      <div className="flex items-center justify-center p-1 bg-editor-input-selected focus-visible:outline-none">
        <Popover open={openPopOver} onOpenChange={setOpenPopOver}>
          <PopoverAnchor
            placement="bottom"
            onClick={() => setOpenPopOver(!openPopOver)}
          >
            <div className="grigora-singleborder__anchor flex items-center">
              <div
                className="w-[18px] h-[18px] rounded-full "
                style={{
                  backgroundColor: value?.color,
                  boxShadow: "inset 0 0 0 1px rgb(0 0 0 / 20%)",
                }}
              ></div>
            </div>
          </PopoverAnchor>
          <PopoverContent className="!bg-editor-light-main !z-[1000] !shadow-editor-floating-elements !rounded-[10px]">
            <div className="p-4">
              <GlobalSketchPicker
                value={value?.color}
                onChange={(val) => onChange({ ...value, color: val })}
              />
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}

export default SingleBorderInput;
